import { clsx } from "clsx";

export default function Container(props: {
  children?: React.ReactNode;
  className?: string;
}) {
  return (
    <div
      className={clsx(
        "mx-auto max-w-7xl px-5 md:px-8",
        props.className ? props.className : ""
      )}
    >
      {props.children}
    </div>
  );
}
